import * as React from "react"
const UsersIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#A1A1A1"
      d="M5 9.167a3 3 0 1 1 0-6 3 3 0 0 1 0 6ZM5 4.5a1.667 1.667 0 1 0 0 3.333A1.667 1.667 0 0 0 5 4.5Zm5 11.333V15.5a5 5 0 1 0-10 0v.333a.667.667 0 1 0 1.333 0V15.5a3.666 3.666 0 1 1 7.334 0v.333a.667.667 0 1 0 1.333 0Zm6-3.333a4.666 4.666 0 0 0-7.778-3.478.667.667 0 1 0 .89.993 3.334 3.334 0 0 1 5.555 2.485.667.667 0 1 0 1.333 0Zm-4.333-6a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-4.667a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334Z"
    />
  </svg>
)
export default UsersIcon
